module.exports = __webpack_public_path__ + "static/media/Html5.b23cf012.png";